import type { MainPoiCategory } from '$lib/components/pois/types';

export const defaultPoiCategories = [
	'ACCOMMODATION',
	'RESTAURANT',
	'TOURISM',
] satisfies MainPoiCategory[];

export const DEFAULT_ACCOMMODATION_AVAILABILITY_START_DATES_DAYS_DIFF = 28;
export const DEFAULT_ACCOMMODATION_AVAILABILITY_END_DATES_DAYS_DIFF = 29;
